import { render, staticRenderFns } from "./DeleteCategoryInTwoSteps.vue?vue&type=template&id=6c409949&"
import script from "./DeleteCategoryInTwoSteps.vue?vue&type=script&lang=js&"
export * from "./DeleteCategoryInTwoSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports